<coin-v2-card
  styleVariant="large"
  padding="none">
  <div class="activity-type">
    <div
      class="left"
      [style.background-color]="activityTypeInfo?.backgroundColor">
      <mat-icon [svgIcon]="activityTypeInfo?.svgIcon">{{ activityTypeInfo?.icon }}</mat-icon>
    </div>
    <div class="right">
      <p
        #title
        class="bold"
        coinEllipsisTooltip
        matTooltip>
        {{ itemTitle | translate }}
      </p>
      <p
        #subTitle
        coinEllipsisTooltip
        matTooltip
        class="subtitle">
        {{ itemSubtitle | translate }}

        @if (itemLink) {
          <a
            matTooltip="{{ 'activity-stream.open-in-new-tab' | translate }}"
            target="_blank"
            [href]="itemLink">
            <mat-icon>open_in_new</mat-icon>
          </a>
        }
      </p>
      @if (item()?.entityTitle) {
        <p
          class="entity-title"
          [matTooltip]="item()?.entityTitle">
          {{ item()?.entityTitle }}
        </p>
      }
    </div>
  </div>
  <div
    class="event-details"
    [ngClass]="{ 'html-view': !hasMultipleChangedProperties && isHtmlBlock(item(), itemChangedProperty) }">
    @if (item()?.metadata) {
      @if (typeof item()?.metadata.value === 'boolean') {
        <div class="information-changed">
          <div class="old-value">
            <p
              coinEllipsisTooltip
              matTooltip>
              {{ !item()?.metadata.value }}
            </p>
            <div class="arrow">
              <mat-icon>keyboard_arrow_right</mat-icon>
            </div>
          </div>
          <div class="new-value">
            <p
              class="bold"
              coinEllipsisTooltip
              matTooltip>
              {{ item()?.metadata.value }}
            </p>
          </div>
        </div>
      } @else {
        <div class="no-details">
          <p>{{ 'activity-stream.no-further-details' | translate }}</p>
        </div>
      }
    } @else {
      @if (hasMultipleChangedProperties && !isRecommendation) {
        @switch (item()?.itemType) {
          @default {
            <coin-c-activity-stream-multiple-items
              [changedProperties]="item().changedProperties"
              [item]="item()"
              [showDetails]="item().isDetailVisible"
              (showDetailsClicked)="onShowClicked()"
              (closeDetails)="onCloseDetails()"></coin-c-activity-stream-multiple-items>
          }
          @case (activityStreamItemType.ManagerChanged) {
            <div class="managers-changed">
              @for (itemChangedProperty of itemChangedProperties; track itemChangedProperty) {
                <div class="managers-changed-item">
                  <ng-container
                    [ngTemplateOutlet]="employeeChange"
                    [ngTemplateOutletContext]="{ $implicit: itemChangedProperty }"></ng-container>
                </div>
              }
            </div>
          }
        }
      } @else {
        @if (item()?.changedProperties?.length) {
          @switch (item()?.itemType) {
            @default {
              <div class="information-changed">
                @if (!isHtmlBlock(item(), itemChangedProperty)) {
                  <div class="old-value">
                    <p
                      coinEllipsisTooltip
                      matTooltip>
                      {{
                        isDisplayedUnformatted(itemChangedProperty)
                          ? itemChangedProperty?.originalValue
                          : (($any(itemChangedProperty?.originalValue) | translate | formatUnknownValue) ?? '-')
                      }}
                    </p>
                    <div class="arrow">
                      <mat-icon>keyboard_arrow_right</mat-icon>
                    </div>
                  </div>
                }
                <div class="new-value">
                  @if (isHtmlBlock(item(), itemChangedProperty)) {
                    <p
                      class="html"
                      coinEllipsisTooltip
                      matTooltip
                      [innerHTML]="itemChangedProperty.currentValue"></p>
                  } @else {
                    <p
                      class="bold"
                      coinEllipsisTooltip
                      matTooltip>
                      {{
                        isDisplayedUnformatted(itemChangedProperty)
                          ? itemChangedProperty?.currentValue
                          : ($any(itemChangedProperty?.currentValue) | translate | formatUnknownValue)
                      }}
                    </p>
                  }
                </div>
              </div>
            }
            @case (activityStreamItemType.ApproverChanged) {
              <div class="approver-changed">
                <ng-container
                  [ngTemplateOutlet]="employeeChange"
                  [ngTemplateOutletContext]="{ $implicit: itemChangedProperty }"></ng-container>
              </div>
            }
            @case (activityStreamItemType.ManagerChanged) {
              <div class="manager-changed">
                <ng-container
                  [ngTemplateOutlet]="employeeChange"
                  [ngTemplateOutletContext]="{ $implicit: itemChangedProperty }"></ng-container>
              </div>
            }
            @case (activityStreamItemType.ShortlistChanged) {
              <div class="manager-changed">
                <ng-container
                  [ngTemplateOutlet]="employeeChange"
                  [ngTemplateOutletContext]="{ $implicit: itemChangedProperty }"></ng-container>
              </div>
            }
            @case (activityStreamItemType.StatusChanged) {
              <div class="status-changed">
                <div class="old-value">
                  <p class="bold">{{ itemChangedProperty?.originalValue ?? '-' }}</p>
                  <div class="arrow">
                    <mat-icon>keyboard_arrow_right</mat-icon>
                  </div>
                </div>
                <div class="new-value">
                  <p class="bold">{{ itemChangedProperty?.currentValue }}</p>
                </div>
              </div>
            }
            @case (activityStreamItemType.NewRecommendationAdded) {
              <div class="recommendation-state-changed">
                <ng-container [ngTemplateOutlet]="recommendationChange"></ng-container>
              </div>
            }
            @case (activityStreamItemType.NewTalentAddedToPool) {
              <div class="recommendation-state-changed">
                <ng-container [ngTemplateOutlet]="recommendationChange"></ng-container>
              </div>
            }
            @case (activityStreamItemType.StateChanged) {
              <div class="recommendation-state-changed">
                <ng-container [ngTemplateOutlet]="recommendationChange"></ng-container>
              </div>
            }
            @case (activityStreamItemType.TalentRemovedFromPool) {
              <div class="recommendation-state-changed">
                <ng-container [ngTemplateOutlet]="recommendationChange"></ng-container>
              </div>
            }
            @case (activityStreamItemType.RevertedRecommendation) {
              <div class="recommendation-state-changed">
                <ng-container [ngTemplateOutlet]="recommendationChange"></ng-container>
              </div>
            }
            @case (activityStreamItemType.OtherEvent) {
              <div class="other-event">
                <div class="new-value">
                  <p>{{ itemChangedProperty?.currentValue }}</p>
                </div>
              </div>
            }
          }
        } @else {
          <div class="no-details">
            <p>{{ 'activity-stream.no-further-details' | translate }}</p>
          </div>
        }
      }
    }

    <ng-template #recommendationChange>
      <div class="left">
        <coin-siemens-energy-employee-preview
          [showOrgCode]="true"
          [employee]="item()?.talent"></coin-siemens-energy-employee-preview>
      </div>
      <div class="right">
        @if (talentPoolReferenceTrackTitle) {
          <p>{{ talentPoolReferenceTrackTitle }}</p>
        }
        @if (recommendationState) {
          <coin-v2-dual-pill
            [contentLeft]="'succession-management.' + pascalcaseToKebabCase(recommendationState) | translate"
            [textRight]="item()?.updatedAt | date: 'MM/dd/yyyy'"
            [themeColor]="$any(getColorForRecommendationState(recommendationState))"></coin-v2-dual-pill>
        }
      </div>
    </ng-template>

    <ng-template
      #employeeChange
      let-changedProperty>
      <div class="old-value">
        @if (changedProperty?.originalValue) {
          <coin-siemens-energy-employee-preview
            [employee]="changedProperty?.originalValue | employeeId$ | async"></coin-siemens-energy-employee-preview>
        } @else {
          <p>-</p>
        }
        <div class="arrow">
          <mat-icon>keyboard_arrow_right</mat-icon>
        </div>
      </div>

      <div class="new-value">
        @if (changedProperty?.currentValue) {
          <coin-siemens-energy-employee-preview
            [employee]="changedProperty?.currentValue | employeeId$ | async"></coin-siemens-energy-employee-preview>
        } @else {
          <p>-</p>
        }
      </div>
    </ng-template>
  </div>
  <div class="event-by">
    @if (item()?.eventBy?.gid) {
      <coin-siemens-energy-employee-preview
        [employee]="item()?.eventBy"
        [showGid]="true"></coin-siemens-energy-employee-preview>
    } @else {
      <div class="event-by-system">
        <mat-icon>settings_suggest</mat-icon>
        <p>{{ 'activity-stream.event-by-system' | translate }}</p>
      </div>
    }
  </div>
  <div class="time">
    <p class="bold">{{ item()?.eventAt | date: 'MM/dd/yy' }}</p>
    <p>{{ item()?.eventAt | date: 'HH:mm:ss' }}</p>
  </div>
</coin-v2-card>
